import { makeStyles } from '@material-ui/core';

const useInputLabelStyles = makeStyles((theme) => {
  return ({
    root: {
      display: 'flex',
      alignItems: 'center',

      '& svg': {
        marginLeft: '10px',
        color: 'var(--teal-blue)'
      },

      '& a': {
        marginLeft: '5px',
        color: 'var(--primary-light)'
      }
    },
    errorLabel: {
      color: 'var(--light-venetian-red) !important',

      '& span': {
        color: 'var(--light-venetian-red) !important'
      }
    },
    requiredAsterisk: {
      marginLeft: '3px',
      color: 'var(--light-venetian-red) !important'
    }
  });
});

export default useInputLabelStyles;